import { RolexContainer } from './Container'
import { RolexRichText } from './RichText'
import { Heading } from '@components/rolex-ui/Heading'
import { cn } from '@lib/cn'
import { RolexPageIntro as RolexPageIntroModel } from '@lib/kontent/models/RolexPageIntro'
import { FC } from 'react'

type RolexPageIntroProps = {
  pretitle?: string
  title: string
  description: RolexPageIntroModel['description']
  titleTag: string
  className?: string
  children?: React.ReactNode
}

export const RolexPageIntro: FC<RolexPageIntroProps> = ({
  pretitle,
  title,
  description,
  titleTag,
  className,
  children,
}) => {
  return (
    <div className={cn('py-[60px] lg:py-[90px]', className)}>
      <RolexContainer
        className={cn('flex flex-col items-start gap-5 lg:grid lg:grid-cols-12 ', className)}
      >
        <div className="flex flex-col gap-2 lg:col-span-5 lg:col-start-1">
          {pretitle && (
            <Heading variant="headline26" as="h4" className="whitespace-pre-line text-rolexBrown">
              {pretitle}
            </Heading>
          )}
          <Heading
            variant="headline50"
            as={titleTag as any}
            className="whitespace-pre-line text-rolexBrown"
          >
            {title}
          </Heading>
        </div>
        <div className="lg:col-span-5 lg:col-start-7">
          <RolexRichText content={description} />
          {children && children}
        </div>
      </RolexContainer>
    </div>
  )
}
